// extracted by mini-css-extract-plugin
export default {"gsmaMGEARContainer":"App_gsmaMGEARContainer__SzMHA"};